interface ProjectCardProps {
  id: string;
  title: string;
  description?: string | null;
  conversationCount: number;
  fileCount: number;
  updatedAt: string;
  participants: Array<{ user: { id: string; name: string; email: string } }>;
  onClick: () => void;
}

function formatRelativeTime(dateStr: string): string {
  const now = Date.now();
  const d = new Date(dateStr).getTime();
  const diff = now - d;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString();
}

function getInitials(name: string): string {
  return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
}

export function ProjectCard({ title, description, conversationCount, fileCount, updatedAt, participants, onClick }: ProjectCardProps) {
  const maxAvatars = 3;
  const shownParticipants = participants.slice(0, maxAvatars);
  const overflow = participants.length - maxAvatars;

  return (
    <div className="proj-card" onClick={onClick}>
      <div className="proj-card-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
        </svg>
      </div>
      <div className="proj-card-body">
        <div className="proj-card-title">{title}</div>
        {description && <div className="proj-card-desc">{description}</div>}
        <div className="proj-card-meta">
          <span className="proj-card-stat">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
            {conversationCount}
          </span>
          <span className="proj-card-stat">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
            {fileCount}
          </span>
        </div>
      </div>
      <div className="proj-card-right">
        <span className="proj-card-time">{formatRelativeTime(updatedAt)}</span>
        <div className="proj-card-participants">
          {shownParticipants.map(p => (
            <div key={p.user.id} className="proj-card-part" title={p.user.name}>
              {getInitials(p.user.name)}
            </div>
          ))}
          {overflow > 0 && (
            <div className="proj-card-part">+{overflow}</div>
          )}
        </div>
      </div>
    </div>
  );
}
